<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="card-header">
        <p class="card-header-title">Add New Student</p>
    </div>
    <div class="card-content">
        <div class="content">            
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="First Name" v-model="input.firstName">
                </div>
        </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Last Name" v-model="input.lastName">
                </div>
        </div>
        <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Father's Name" v-model="input.father">
                </div>
        </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Father's ID/IC (Accept only letters and numbers)" v-model="input.fatherID">
                </div>
        </div>
        <div class="field">
            <div class="control">
                <input class="input is-success" type="text" placeholder="Father's E-mail" v-model="input.fatherEmail">
            </div>
        </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Mother's Name" v-model="input.mother">
                </div>
        </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Mother's ID/IC (Accept only letters and numbers)" v-model="input.motherID">
                </div>
        </div>
        <div class="field">
            <div class="control">
                <input class="input is-success" type="text" placeholder="Mother's E-mail" v-model="input.motherEmail">
            </div>
        </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Contact Number" v-model="input.contactNo1">
                </div>
        </div>
            <div class="field">
                <div class='ui two buttons'>
                    <button class='button is-primary' v-on:click="sendForm()">Create</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    props: ['kelasID'],
    components:{
        Loading,
    },
    data() {
        return {
            input: {
                idType: 1,  //for father's ID
                kelasID: '0',
                firstName: '',
                lastName: '',
                father: '',
                fatherID: '',
                fatherEmail: '',
                mother: '',
                motherID: '',
                motherEmail: '',
                contactNo1: '',
                isCreating: false,
            },
            isLoading: false,
            kelasList: [],
            result: "",
            errors: []
        };
    },
    beforeMount() {
        this.openForm()
    },
    created() {
    },
    methods: {
        openForm() {
            this.input.isCreating = true;
        },
        closeForm() {
            this.input.isCreating = false;
        },
        sendForm() {
            console.log("imini 113")
            let self = this

            if (this.input.firstName.length > 0) {
                const firstName = this.input.firstName;
                const lastName = this.input.lastName;
                this.$emit('add-students', {
                    firstName,
                    lastName,
                    done: false,
                });

                if (this.input.fatherID != null){
                    if (this.input.fatherID.length > 0){
                        this.input.fatherID = this.input.fatherID.replace(/[^A-Z0-9]/ig, "");
                    }
                }

                if (this.input.motherID != null){
                    if (this.input.motherID.length > 0){
                        this.input.motherID = this.input.motherID.replace(/[^A-Z0-9]/ig, "");
                    }
                }

                self.isLoading = true;

                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/students/add/', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    kelasID: self.kelasID,
                    firstName: firstName,
                    lastName: lastName,
                    father: self.input.father,
                    fatherID: self.input.fatherID,                
                    fatherEmail: self.input.fatherEmail,
                    mother: self.input.mother,            
                    motherID: self.input.motherID,            
                    motherEmail: self.input.motherEmail,
                    contactNo1: self.input.contactNo1
                })
                .then(response => {
                    self.isLoading = false;
                    if (response.data.success == false) {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: response.data.msg,
                            type: 'is-success',
                            duration: 3000
                        })
                    }

                    this.input.firstName = '';
                    this.input.lastName = '';
                    this.input.father = '';
                    this.input.fatherID = '';
                    this.input.fatherEmail = '';
                    this.input.mother = '';
                    this.input.motherID = '';
                    this.input.motherEmail = '';
                    this.input.contactNo1 = '';
                    this.input.isCreating = false;
                    this.$parent.getStudentsInThisClass()
                })
                .catch(e => {
                    self.isLoading = false;
                    console.log(e.response)
                    if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })
            } else {
                alert("Please at least enter the student's first name.");
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Manage/Students/AddStudents.vue